import { z } from 'zod';

export const CreateCategorySchema = z.object({
    name: z.string().min(1, 'Category name is required').max(100, 'Category name must be less than 100 characters'),
});

export type CreateCategoryFormData = z.infer<typeof CreateCategorySchema>;

export const CreateStockItemSchema = z.object({
    name: z.string().min(1, 'Item name is required').max(100, 'Item name must be less than 100 characters'),
    category: z.string().min(1, 'Category is required'),
    quantity: z.number().min(0, 'Quantity must be 0 or greater'),
    unit: z.string().min(1, 'Unit is required').max(20, 'Unit must be less than 20 characters'),
    itemCode: z.string().optional(),
    purchasingPrice: z.number().min(0, 'Purchasing price must be 0 or greater').optional(),
    sellingPrice: z.number().min(0, 'Selling price must be 0 or greater').optional(),
});

export type CreateStockItemFormData = z.infer<typeof CreateStockItemSchema>;